/* IMPORTS START */
import auth from '@/api/endpoint/auth'
import country from '@/api/endpoint/country'
import radio from '@/api/endpoint/radio'
import state from '@/api/endpoint/state'
import tag from '@/api/endpoint/tag'
import apiResponseEnum from '@/api/enums/apiResponseEnum'
import HTTP from '@/lib/data/api/http'
/* IMPORTS END */

export const API = {
  get restRequest () {
    return HTTP.request
  },
  get restRequestAll () {
    return HTTP.requestAll
  },
  get restClient () {
    return HTTP
  },

  get endpoint () {
    return {
      /* RESOURCES */
      auth   : auth,
      radio  : radio,
      tag    : tag,
      country: country,
      state  : state
    }
  },

  get endpointConfig () {
    return {
      /* ENDPOINTS */
      auth: {
        login: {
          path  : 'auth/login',
          method: HTTP.method.post
        },
        logout: {
          path  : 'auth/logout',
          method: HTTP.method.post
        }
      },
      radio: {
        getByCountry: {
          path  : 'stations/bycountry/{country}',
          method: HTTP.method.get
        },

        getByLanguage: {
          path  : 'stations/bylanguage/{language}',
          method: HTTP.method.get
        },

        getByTag: {
          path  : 'stations/bytag/{tag}',
          method: HTTP.method.get
        }
      },
      tag: {
        getAll: {
          path  : 'tags',
          method: HTTP.method.get
        },
        getByFilter: {
          path  : 'tags/{filter}',
          method: HTTP.method.get
        }
      },
      country: {
        getAll: {
          path  : 'countries',
          method: HTTP.method.get
        },
        getByFilter: {
          path  : 'countries/{filter}',
          method: HTTP.method.get
        }
      },
      state: {
        getAll: {
          path  : 'states',
          method: HTTP.method.get
        },
        getByFilter: {
          path  : 'states/{filter}',
          method: HTTP.method.get
        },
        getByCountry: {
          path  : 'states/{country}/{filter}',
          method: HTTP.method.get
        }
      }
    }
  },

  responseData     : response => response?.data?.data || null,
  responseErrors   : response => response?.data?.error || null,
  isResponseSuccess: response =>
    response?.status === apiResponseEnum.SUCCESS
    && response?.data?.status === apiResponseEnum.SUCCESS
    && API.responseData(response) && !API.responseErrors(response)
}

export { default as HTTP } from '@/lib/data/api/http'
export default API
